import { css, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

@customElement("umb-market-button")
export class UmbMarketButton extends LitElement {
  @property()
  type: "button" | "submit" | "reset" | "menu" = "button";

  @property({ reflect: false })
  href?: string;

  @property({ reflect: false })
  target: "_blank" | "_self" | "_parent" | "_top" = "_self";

  @property({ type: Boolean, reflect: true, attribute: "has-append" })
  hasAppend = false;

  #onAppendSlotChange(event: Event) {
    const slot = event.target as HTMLSlotElement;
    this.hasAppend = slot.assignedNodes({ flatten: true }).length > 0;
  }

  render() {
    if (this.href) {
      return html`<a .href=${this.href} .target=${this.target}
        ><slot></slot
      ></a>`;
    }
    return html`<button type=${this.type}>
      <slot></slot
      ><slot name="append" @slotchange=${this.#onAppendSlotChange}></slot>
    </button>`;
  }

  static styles = css`
    :host {
      display: flex;
      width: var(--button-width, 100%);
      position: relative;
      box-sizing: border-box;
      border-radius: var(--button-border-radius, var(--xs-spacer));
      background: var(--button-background, white);
      margin: var(--button-margin, 0);
      padding: var(--button-padding, 8px 12px);
      color: var(--button-color, var(--uui-color-text));
      line-height: var(--button-line-height, var(--m-spacer));
      justify-content: center;
      transition: background 0.3s ease-in-out, color 0.3s ease-in-out;
    }

    a {
      color: inherit;
      text-decoration: none;
      display: flex;
      align-items: center;
      width: var(--button-width, 100%);
    }

    button {
      display: flex;
      cursor: var(--button-cursor, pointer);
      font-family: inherit;
      border: 0;
      background: transparent;
      color: inherit;
      text-decoration: none;
      flex: 1;
      padding: 0;
      justify-content: var(--button-text-align, center);
      font-size: var(--button-font-size, var(--s-spacer));
      max-width:100%;
    }

    :host(:hover) {
      cursor: pointer;
      background: var(--button-background, var(--uui-color-current));
      color: var(--button-hover-color, var(--uui-color-default));
    }

    button > svg * {
      transition: fill 240ms;
    }

    :host(:hover) > svg * {
      --circle-fill: var(--grey);
      --fill: var(--uui-color-default);
    }

    :host([disabled]) {
      pointer-events: none;
      opacity: 0.5;
    }

    :host([has-append]) slot:first-child {
      flex: 1 1 auto;
      min-width: 0;
    }

    :host([has-append]) slot:last-child {
      flex: none;
    }
  `;
}
